module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAy0lEQVQokY2SIW7DYAyFDQYLAgsHBnqISR0Y3A1KIkXv8y9vIEcIK+juMNgDFBT2AD1AwcBgYeFAwF/QRYqqNJ0lS7bsT3p6tpmZSXp1969bCXy7+87MzIAlkEeyjYgJkDtgbDkD2d23wM8QcOrVvz1gNwj0+k9gfRcAjsBz0zQPV5KGAUnzsiwLSXN3X/1LUheS3oBDREwlbYD3QZdSSi9dHRHTq/l+1FZ33wAtMKuq6gnI9+7wIWnxB11kp5Qeb71EXdcFsO9JnJwB6/QGPRZgVooAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/images/ic_01.png
// module id = uS2U
// module chunks = 2